import { Tooltip, tooltipClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
import type { TooltipProps } from "@mui/material/Tooltip";

export const StyledTooltip = styled(
  ({ className, ...props }: TooltipProps & { maxWidth: number }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  )
)(({ theme, maxWidth }) => {
  const tooltipBorderRadius =
    typeof theme.shape.borderRadius === "number"
      ? theme.shape.borderRadius * 2
      : `calc(${theme.shape.borderRadius} * 2)`;

  return {
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      boxShadow: theme.shadows[3],
      borderRadius: tooltipBorderRadius,
      padding: theme.spacing(1.5),
      maxWidth: maxWidth,
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.background.paper,
    },
  };
});
